export enum SentryEventType {
  Log = 'coachBotAggregatorSentryLogEvent',
  Error = 'coachBotAggregatorSentryErrorEvent',
  PostBackend = 'coachBotAggregatorPostEvent',
}
